var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2947 4.70532C11.6842 4.31578 12.3158 4.31578 12.7053 4.70532C13.0946 5.0946 13.0949 5.72568 12.7059 6.11531L7.83 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.83L12.7059 17.8847C13.0949 18.2743 13.0946 18.9054 12.7053 19.2947C12.3158 19.6842 11.6842 19.6842 11.2947 19.2947L4 12L11.2947 4.70532Z",
    fill: "#C2D1D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2947 4.70532C11.6842 4.31578 12.3158 4.31578 12.7053 4.70532C13.0946 5.0946 13.0949 5.72568 12.7059 6.11531L7.83 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.83L12.7059 17.8847C13.0949 18.2743 13.0946 18.9054 12.7053 19.2947C12.3158 19.6842 11.6842 19.6842 11.2947 19.2947L4 12L11.2947 4.70532Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1385)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#3E3E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.bac331b628eb6c2ac660327ba4a745a7.svg";
export { ForwardRef as ReactComponent };